module.exports = __webpack_public_path__ + "media/images/call-951ea1d9b12ef988ad6f96a8f3491e27.png";